import { Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { SessionActions } from './session-actions';
import { DeviceActions } from '../device/device-actions';
import { Action } from '@ngrx/store';
import { tap } from 'rxjs/operators';
/**
 * Created by ashok on 10/05/17.
 */

@Injectable()
export class SessionEffects {

    constructor(private actions$: Actions, private sessionActions: SessionActions) {

    }

    // @Effect({dispatch: false})
    // deviceRegistered$ = this.actions$.pipe(ofType(DeviceActions.DEVICE_REGISTERED))
    //     .subscribe((action: Action)=>{
    //         this.sessionActions.checkAndSignIn();
    //     })



    deviceRegistered$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceActions.DEVICE_REGISTERED), tap((action: Action) => {
                this.sessionActions.checkAndSignIn();
            })
        ), { dispatch: false });


}